import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { FileText, AlertTriangle, ArrowRight } from "lucide-react";

export default function PolicyReviewCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/policies").then((r) => setData(r.data)).catch((e) => logError("policy-review-card", e)); }, []);
  if (!data?.packs?.length) return null;
  const attention = data.overdue + data.due_soon;
  return (
    <div className="bg-card border border-border rounded-2xl p-6 shadow-sm mb-8 flex flex-wrap items-center gap-4" data-testid="dashboard-policy-reviews">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${data.overdue ? "bg-red-100 text-red-700" : attention ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}>
        {data.overdue ? <AlertTriangle className="w-5 h-5" /> : <FileText className="w-5 h-5" />}
      </div>
      <div className="flex-1 min-w-[200px]">
        <p className="font-display font-semibold">Policy reviews</p>
        <p className="text-sm text-muted-foreground" data-testid="dashboard-policy-reviews-text">
          {data.overdue ? `${data.overdue} overdue` : ""}{data.overdue && data.due_soon ? " · " : ""}{data.due_soon ? `${data.due_soon} due in the next 30 days` : ""}
          {!attention && `${data.policies.length} policies · all up to date or awaiting a review date`}
        </p>
      </div>
      <Link to="/policies" className="text-sm text-primary font-medium inline-flex items-center gap-1 hover:underline" data-testid="dashboard-policy-reviews-link">Open My Policies <ArrowRight className="w-4 h-4" /></Link>
    </div>
  );
}
